import { Box } from '@mui/material';
import { PropsWithChildren } from 'react';

const LABEL_SX = {
  m: 0,
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 0,
  lineHeight: 1.35,
} as const;

const getLabelSx = (color: string) => ({
  ...LABEL_SX,
  color,
});

type InterruptionTypeLabelProps = PropsWithChildren<{
  color: string;
}>;

const InterruptionTypeLabel = ({ children, color }: InterruptionTypeLabelProps) => (
  <Box component="p" sx={getLabelSx(color)}>
    {children}
  </Box>
);

export default InterruptionTypeLabel;
